module.exports = __webpack_public_path__ + "img/9.981d8997.png";